// Internal shared module for cmsStore split. NOT part of the public API —
// consumers should always import from '@/lib/cmsStore', which re-exports the
// public surface from this and its sibling sub-modules.

import { emitCmsChange } from './cmsEvents';

export const STORAGE_KEYS = {
  settings: 'ck_cms_settings',
  conversations: 'ck_cms_conversations',
  media: 'ck_cms_media',
  content: 'ck_cms_content',
  auth: 'ck_cms_auth',
  articles: 'ck_cms_articles',
  services: 'ck_cms_services',
  socialLinks: 'ck_cms_social_links',
} as const;

// Fire-and-forget sync helper. Logs errors but never throws so admin UI
// isn't blocked by transient network hiccups.
//
// Window events `ck:sync-ok` / `ck:sync-fail` are wire-protocol — consumed
// by ChatWidget.tsx (offline banner) and asserted in ChatWidget.test.tsx.
// Do not change the event names or detail shape.
export function syncToServer<T>(
  fn: () => Promise<T>,
  scope: Parameters<typeof emitCmsChange>[0],
): void {
  fn()
    .then(() => {
      emitCmsChange(scope);
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('ck:sync-ok', { detail: { scope } }));
      }
    })
    .catch((err) => {
      console.warn(`[cmsStore] server sync failed (${scope})`, err);
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('ck:sync-fail', { detail: { scope } }));
      }
    });
}
